import { render, staticRenderFns } from "./ImportTeachers.vue?vue&type=template&id=74fe4f76"
import script from "./ImportTeachers.vue?vue&type=script&lang=js"
export * from "./ImportTeachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports